import { render, staticRenderFns } from "./PasaportCard.vue?vue&type=template&id=34ba8b91&scoped=true"
import script from "./PasaportCard.vue?vue&type=script&lang=ts"
export * from "./PasaportCard.vue?vue&type=script&lang=ts"
import style0 from "./PasaportCard.vue?vue&type=style&index=0&id=34ba8b91&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34ba8b91",
  null
  
)

export default component.exports